import { render, staticRenderFns } from "./installDetails.vue?vue&type=template&id=666c920a&scoped=true&"
import script from "./installDetails.vue?vue&type=script&lang=js&"
export * from "./installDetails.vue?vue&type=script&lang=js&"
import style0 from "./installDetails.vue?vue&type=style&index=0&id=666c920a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c920a",
  null
  
)

export default component.exports